import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import GlobalStyles from './GlobalStyles';
import buildScales from './scales';
import { useMatchMedia } from '../hooks/useMatchMedia';
import { useCurrentBreakpoint } from '../hooks/useCurrentBreakpoint';
import createBreakpoints from './createBreakpoints';
import colors from './colors';
import themes from './themes';
import { hexToRGB } from './assets';

export const R_SCALE_1 = 1;
export const R_SCALE_2 = 2;

export const T_SCALE_1 = 1;
export const T_SCALE_2 = 2;

const SMALL_SCREEN_MARGIN = 16;
const LARGE_SCREEN_MARGIN = 20;
const SMALL_SCREEN_GUTTER = 16;
const LARGE_SCREEN_GUTTER = 20;

const fontWeights = {
  light: 300,
  regular: 400,
  medium: 600,
};

export const buildTheme = (breakpoints, props = {}, isSmallScreen = false) => {
  const { extensions } = props;

  const rScale = isSmallScreen ? R_SCALE_1 : R_SCALE_2;
  const tScale = isSmallScreen ? T_SCALE_1 : T_SCALE_2;

  const margin = isSmallScreen ? SMALL_SCREEN_MARGIN : LARGE_SCREEN_MARGIN;
  const gutter = isSmallScreen ? SMALL_SCREEN_GUTTER : LARGE_SCREEN_GUTTER;

  const scales = buildScales(props, isSmallScreen);

  const name = props.themeName || themes.RED_BRAND;
  const darkMode = !!props.darkMode;

  return {
    name,
    breakpoints,
    rScale,
    tScale,
    margin,
    gutter,
    hexToRGB,
    darkMode,
    fontWeight: fontWeights,
    colors: {
      ...colors,
      ...props.colors,
    },
    isRScale: (scale) => rScale === scale,
    isTheme: (theme) => theme === name,
    isRedBrand: themes.RED_BRAND === name,
    ...scales,
    extensions: extensions || {},
  };
};

const StyleProvider = (props) => {
  const breakpoints = createBreakpoints();
  // as we skip supporting ExtraLarge breakpoint we have two scales only
  const currentBreakpoint = useCurrentBreakpoint(breakpoints);
  const isSmallScreen = useMatchMedia(breakpoints.down(breakpoints.md));

  const theme = buildTheme(breakpoints, props, isSmallScreen);

  return (
    <ThemeProvider theme={{ ...theme, currentBreakpoint }}>
      <GlobalStyles />
      {props.children}
    </ThemeProvider>
  );
};

StyleProvider.propTypes = {
  children: PropTypes.node,
};

export default StyleProvider;
